@if (params) {
  <div class="modal">
    <div class="modal-ctn">
      <div class="title" [innerHTML]="params.title | sanitizeHtml"></div>
      @if (params.hideControls) {
        <div class="tab">
          <input type="checkbox" id="chck1">
          <label class="tab-label" for="chck1">{{ 'EXPAND_CONFIRMATION' | translate }}</label>
          <div class="tab-content">
            <div class="buttons">
              @for (button of params.buttons; track button) {
                <div (click)="button.method()">
                  {{ button.text }}
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (!(params.hideControls)) {
        <div class="buttons">
          @for (button of params.buttons; track button) {
            <div (click)="button.method()">
              {{ button.text }}
            </div>
          }
        </div>
      }
    </div>
  </div>
}